module.exports = __webpack_public_path__ + "static/img/logoEn.72359a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoEn.png
// module id = H1TL
// module chunks = 51